import {HospitalsService} from '../../services/hospitals.service';
import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {HospitalBranchesService} from "../../services/hospital-branches.service";

@Component({
  selector: 'app-hospital',
  templateUrl: './hospital.component.html',
  styleUrls: ['./hospital.component.css']
})
export class HospitalComponent implements OnInit {

  hospital = {
    "id": null,
    "email": null,
    "name": null
  }

  branches = []


  constructor(private hospital_service: HospitalsService,
              private activatedRoute: ActivatedRoute,
              private hospital_branch_service: HospitalBranchesService) {
  }

  ngOnInit() {

    this.activatedRoute.params.subscribe(
      (params: Params) => {
        let hospitalId = params['id'];
        this.hospital_service.getById(hospitalId)
          .subscribe(
            hospital => {
              this.hospital = hospital;
              this.hospital_branch_service.getHospitalBranches(this.hospital.id).subscribe(branches => {
                this.branches = branches
                console.log(this.branches)
              }, error => {
                alert(error)
              });
            },
            error => {
              alert(error)
            });
      }, error => {
        alert("Could not data for hospital")
      })
  }


}



// WEBPACK FOOTER //
// ./src/app/components/hospital/hospital.component.ts